var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGearIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    stroke: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#3e4347"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.3 18.3c1.1.2 1.6 1.3 1.1 2.3l-3.2 7.6c-.4 1.1-1.5 1.4-2.4.9L3 24.9c-.9-.6-1.3-1.9-.9-3l1.6-3.8c.4-1 1.7-1.7 2.7-1.5l7.9 1.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 34.8c.9-.6 2-.2 2.5.9l3.2 7.6c.4 1.1-.1 2.1-1.1 2.3l-7.8 1.7c-1.1.2-2.3-.4-2.7-1.5L2.3 42c-.4-1.1 0-2.4.9-3l6.6-4.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3 49.7c.2-1.1 1.3-1.6 2.3-1.1l7.6 3.2c1.1.4 1.4 1.5.9 2.5L24.8 61c-.6.9-1.9 1.3-3 .9L18 60.3c-1-.4-1.7-1.7-1.5-2.7l1.8-7.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8 54.2c-.6-.9-.2-2 .9-2.5l7.6-3.2c1.1-.4 2.1.1 2.3 1.1l1.7 7.8c.2 1.1-.4 2.3-1.5 2.7L42 61.7c-1.1.4-2.4 0-3-.9l-4.2-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7 45.7c-1.1-.2-1.6-1.3-1.1-2.3l3.2-7.6c.4-1 1.5-1.4 2.5-.9l6.8 4.3c.9.6 1.3 1.9.9 3L60.4 46c-.4 1-1.7 1.7-2.7 1.5l-8-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2 29.2c-.9.6-2 .2-2.5-.9l-3.2-7.6c-.4-1.1.1-2.1 1.1-2.3l7.8-1.7c1.1-.2 2.3.4 2.7 1.5l1.6 3.8c.4 1 0 2.4-.9 3l-6.6 4.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.7 14.3c-.2 1.1-1.3 1.6-2.3 1.1l-7.6-3.2c-1.1-.4-1.4-1.5-.9-2.5L39.1 3c.6-.9 1.9-1.3 3-.9l3.8 1.6c1 .4 1.7 1.7 1.5 2.7l-1.7 7.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2 9.8c.6.9.2 2-.9 2.5l-7.6 3.2c-1 .4-2.1-.1-2.3-1.1l-1.7-7.8c-.2-1.1.4-2.3 1.5-2.7L22 2.3c1.1-.4 2.4 0 3 .9l4.2 6.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 6.7C18 6.7 6.7 18 6.7 32S18 57.3 32 57.3S57.3 46 57.3 32S46 6.7 32 6.7zm0 41.2c-8.8 0-15.9-7.1-15.9-15.9S23.2 16.1 32 16.1S47.9 23.2 47.9 32S40.8 47.9 32 47.9z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 12.3c-10.9 0-19.7 8.8-19.7 19.7c0 10.9 8.8 19.7 19.7 19.7S51.7 42.9 51.7 32S42.9 12.3 32 12.3m0 27.2c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5s-3.4 7.5-7.5 7.5",
    fill: "#94989b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32 17c-8.3 0-15 6.7-15 15s6.7 15 15 15s15-6.7 15-15s-6.7-15-15-15m0 22.5c-4.1 0-7.5-3.4-7.5-7.5s3.4-7.5 7.5-7.5s7.5 3.4 7.5 7.5s-3.4 7.5-7.5 7.5",
    fill: "#3e4347"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGearIcon);
export default __webpack_public_path__ + "static/media/gear-icon.baa8a6db5973cb1d44b775591ecbc484.svg";
export { ForwardRef as ReactComponent };